module.exports = __webpack_public_path__ + "images/embed/growl4rails/top.png";